import React from 'react';
import { Button } from 'primereact/button';
import { toast } from 'react-toastify';
import PhotoUploader from './PhotoUploader';

const estimateDataUrlSize = (dataUrl) => {
    if (!dataUrl || typeof dataUrl !== 'string') return 0;
    const parts = dataUrl.split(',');
    if (parts.length < 2) return 0;
    return Math.ceil((parts[1].length * 3) / 4);
};

const getTotalPhotoBytes = (photos = []) => photos.reduce((sum, photo) => sum + estimateDataUrlSize(photo), 0);

const PhotoEvidenceUpload = ({
    label = 'Foto de evidencia',
    value = [],
    onChange,
    disabled,
    readOnly,
    maxPhotos = 10,
    maxSizeMB = 1.5,
    maxTotalBytes = 10 * 1024 * 1024,
    helperText
}) => {
    const photos = Array.isArray(value) ? value.filter(Boolean) : [];
    const maxUploadBytes = maxSizeMB * 1024 * 1024;

    const updatePhotos = (nextPhotos) => {
        if (typeof onChange === 'function') onChange(nextPhotos);
    };

    const addPhoto = (photoValue) => {
        if (!photoValue || typeof photoValue !== 'string') return;
        if (photos.length >= maxPhotos) {
            toast.warn(`Máximo ${maxPhotos} fotos permitidas.`);
            return;
        }

        const nextPhotos = [...photos, photoValue];
        if (getTotalPhotoBytes(nextPhotos) > maxTotalBytes) {
            toast.warn('Se alcanzó el límite total de fotos. Elimina una foto o carga imágenes más pequeñas.');
            return;
        }

        updatePhotos(nextPhotos);
    };

    return (
        <div>
            {!readOnly ? (
                <PhotoUploader
                    label={label}
                    value=""
                    onChange={addPhoto}
                    disabled={disabled}
                    maxUploadBytes={maxUploadBytes}
                    maxDimension={1280}
                    helperText={helperText || `${maxPhotos} fotos. Máximo ${maxSizeMB} MB cada una.`}
                />
            ) : (
                <div>
                    <label className="block font-medium mb-2">{label}</label>
                    <small className="text-500">Solo lectura</small>
                </div>
            )}

            {photos.length > 0 ? (
                <div className="mt-3">
                    <small className="text-500 block mb-2">
                        {photos.length} {photos.length === 1 ? 'foto agregada' : 'fotos agregadas'}
                    </small>
                    <div className="grid">
                        {photos.map((photo, index) => (
                            <div className="col-6 md:col-4" key={`evidence-photo-${index}`}>
                                <div style={{ border: '1px solid rgba(148,163,184,0.4)', borderRadius: '6px', padding: '0.5rem' }}>
                                    <img
                                        src={photo}
                                        alt={`Evidencia ${index + 1}`}
                                        style={{ width: '100%', maxHeight: '120px', objectFit: 'cover', borderRadius: '4px', cursor: 'pointer' }}
                                        onClick={() => window.open(photo, '_blank', 'noopener,noreferrer')}
                                    />
                                    {!readOnly && !disabled ? (
                                        <Button
                                            type="button"
                                            label="Eliminar"
                                            icon="pi pi-times"
                                            className="p-button-danger p-button-text p-button-sm mt-2"
                                            onClick={() => updatePhotos(photos.filter((_, photoIndex) => photoIndex !== index))}
                                        />
                                    ) : null}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ) : (
                readOnly ? <small className="text-500 block mt-2">Sin fotos de evidencia.</small> : null
            )}
        </div>
    );
};

export default PhotoEvidenceUpload;
